<template>
  <div id="help-message" class="help-message">
    <div class="modal-mask" @click="hideModal">
    </div>
    <div class="modal-wrapper">
      <div class="modal-container">
        <button class="modal-default-button close-btn" @click="hideModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>
        <component v-bind:is="help_modal" v-bind:msgText="this.msgText" v-bind:citation-style="this.currentCitationStyle"></component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "HelpMessage",
    data: function () {
      return {
        help_modal: '',
        msg_text: this.msgText,
        currentCitationStyle: "",
      }
    },
    props: ["msgText", "citationSource", "citationStyle"],
    computed: {
      load_modal: {
        get: function () {
          let source = this.$route.params.source ? this.$route.params.source : this.citationSource
          let locale = this.$i18n.locale
          let file_name = (this.msgText !== 'contributors') ? source+"-msg" : 'contributors'
          return () => import(`@/components/helpMessage/${locale}/${file_name}`)
        }
      }
    },
    watch: {
      textType: function (val) {
        this.msg_text = val
        this.help_modal = this.load_modal
      },
    },
    methods: {
        hideModal() {
            this.$emit('close-modal')
            document.body.classList.remove("modal-open")
        }
    },
    mounted() {
      this.help_modal = this.load_modal
      this.currentCitationStyle = this.citationStyle ? this.citationStyle : this.$route.params.style // 지정된게 없다면 파라미터로 가져오기.
    }
}
</script>

<style>
#help-message .modal-mask {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
#help-message .modal-header{
  border-bottom: 0 !important;
}

#help-message .modal-wrapper {
  width: 400px;
  display: table;
  vertical-align: middle;
  z-index: 100;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 50%;
  top: 50%;
  transform: translate(-25%, -50%);
  animation: fadein .5s;
  -moz-animation: fadein .5s; /* Firefox */
  -webkit-animation: fadein .5s; /* Safari and Chrome */
  -o-animation: fadein .5s; /* Opera */
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadein { /* Firefox */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein { /* Safari and Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fadein { /* Opera */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media only screen and (max-width: 991px) {
  #help-message .modal-wrapper {
    transform: translate(-50%, -50%);
  }
}
@media only screen and (max-width: 767px) {
  #help-message .modal-wrapper {
      width: 100%;
      padding: 15px;
  }
}

#help-message .modal-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  position: relative;
}

#help-message .modal-body {
  margin: 0;
}
@media only screen and (max-width: 575px) {
    #help-message .modal-body {
        margin: 0;
    }
}

#help-message .modal-default-button {
  border: 0;
  background: none;
  color: #333333;
  position: absolute;
  left: 90%;
  top: 10px;
}
@media only screen and (min-width: 991px) {
  #help-message .modal-default-button:hover{
      color: black;
  }
}
@media only screen and (max-width: 525px) {
    #help-message .modal-default-button{
        left: 80%;
    }
}

#help-message .modal-header .modal-title{
  font-size: 20px;
  font-weight: bold !important;
  color: #595959;
}
#help-message .modal-body .text-content{
  font-size: 16px;
}
@media only screen and (max-width: 525px) {
  #help-message .modal-header .modal-title{
      font-size: 24px;
  }
  #help-message .modal-body .text-content, #help-message .modal-body p.text-content + ul{
      font-size: 14px;
  }
  #help-message .modal-body p.text-content + ul{
    padding-left: 1rem;
    text-indent: -1rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/HelpMessage.vue